import { t } from "i18next";
import BackButton from "./BackButton";
import InputComponent from "./InputComponent";
import LogoComponent from "./LogoComponent";

export default function PageHeader(props: {
    pageTitle: string, 
    flag: boolean,
    flagSearch: boolean, 
    list?: any[], 
    setFilteredList?: (list: any[]) => void
}) {
    return (
        <div className="d-flex align-items-center justify-content-between pt-3 gap-3 mb-3">
            <div className="d-flex align-items-center gap-3">
                <BackButton/>
                <h1 className="text-white mb-0 text-uppercase">{props.pageTitle}</h1>
            </div>
            {props.flagSearch ? 
            // <div className="d-none w-50 d-lg-block">
            <div className="col-12">
                <InputComponent 
                    list={props.list ?? []} 
                    setFilteredList={props.setFilteredList ?? (() => {})} 
                    isAccomodation = {props.pageTitle == t("text.sponsored") ? true : false}
                />
            </div> 
            : <></> }
            <LogoComponent absolute={props.flag}/>
        </div>
    )
}
